// Vendors
import React, { createContext, useContext, useState } from 'react';
// Types
import { PaymentContextType, StripeType } from './types/payment.context.types';

const PaymentContext = createContext<PaymentContextType>({} as PaymentContextType);

const PaymentContextProvider = ({
  children,
}: {
  children: React.ReactElement;
}): React.ReactElement => {
  const [cardCountry, setCardCountry] = useState('');
  const [cardPublicKey, setCardPublicKey] = useState('');
  const [clientSecret, setClientSecret] = useState('');
  const [stripePromise, setStripePromise] = useState<StripeType>(null);

  return (
    <PaymentContext.Provider
      value={{
        cardCountry,
        cardPublicKey,
        clientSecret,
        setCardCountry,
        setCardPublicKey,
        setClientSecret,
        setStripePromise,
        stripePromise,
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
};

const usePaymentContextConsumerHook = (): PaymentContextType => useContext(PaymentContext);

/* eslint-disable */
const PaymentContextConsumerHOC = (WrappedComponent: React.FC) => (): JSX.Element =>
  (
    <PaymentContextProvider>
      <WrappedComponent />
    </PaymentContextProvider>
  );

export { usePaymentContextConsumerHook, PaymentContextConsumerHOC, PaymentContextProvider };
